import PrivateRoutes from 'components/utils/PrivateRoutes';
import { createBrowserRouter, Navigate } from 'react-router-dom';
import { dashboardRoutes } from 'routes/dashboard';
import { connectionRoutes } from 'routes/connection';
import { environmentRoutes } from 'routes/environment';
import { bookRoutes } from 'routes/book';
import { renewablesRoutes } from 'routes/renewables';
import { portfoliosRoutes } from 'routes/portfolios';
import { loadsRoutes } from 'routes/loads';
import { batteryRoutes } from 'routes/batteries';
import { biddingStrategiesRoutes } from 'routes/biddingStrategies';
import { hedgeContractsRoutes } from 'routes/hedgesContracts';
import { thermalRoutes } from 'routes/thermals';
import { dsmRoutes } from 'routes/dsm';
import { basisConfiguratorRoutes, basisListRoutes, basisSetupRoutes } from 'routes/basis';
import { forwardItemRoutes } from 'routes/forwardItem';
import { mainMarketRoutes } from 'routes/mainMarket';
import { weightingSchemaRoutes } from 'routes/weightingSchema';
import { priceFormulaRoutes } from 'routes/priceFormula';
import { runAStudyRoutes } from 'routes/runAStudy';
import { jobsRoutes } from 'routes/jobs';
import { variablesRoutes } from 'routes/variables';
import { chartsRoutes } from 'routes/charts';
import { expressJobsRoutes } from 'routes/expressJobs';
import { itemCreationWizardRoutes } from 'routes/itemCreationWizard';
import { autoformRoutes } from 'routes/autoform';
import { economicReserveRoutes } from 'routes/economicReserve';
import { fuelAndEmissionsRoutes } from 'routes/fuelAndEmissions';
import { userManagementRoutes } from 'routes/userManagementRoutes';
import { realizedValuesRoutes } from 'routes/realizedValues';
import { shapeSetRoutes } from 'routes/shapeSet';
import { globalConstraintsRoutes } from 'routes/globalConstraints';
import { powerBIRoutes } from 'routes/powerBI';
import { adminRoutes } from 'routes/admin';
import { restorationInputExtractRoutes } from 'routes/restorationInputExtractRoutes';
import { loginRoutes } from 'routes/login';
import { hydroProjectRoutes } from 'routes/hydroProject';
import App from 'App';
import RootErrorElement from 'components/utils/RootErrorElement';
import { reportRoutes } from './reports';

export const router = createBrowserRouter(
    [
        {
            element: <App />,
            errorElement: <RootErrorElement />,
            children: [
                {
                    path: '/wind/*',
                    element: <Navigate to="/renewables" replace />,
                },
                {
                    path: '/solar/*',
                    element: <Navigate to="/renewables" replace />,
                },
                loginRoutes,
                {
                    element: <PrivateRoutes />,
                    children: [
                        reportRoutes,
                        dashboardRoutes,
                        connectionRoutes,
                        environmentRoutes,
                        bookRoutes,
                        renewablesRoutes,
                        portfoliosRoutes,
                        loadsRoutes,
                        batteryRoutes,
                        biddingStrategiesRoutes,
                        hedgeContractsRoutes,
                        thermalRoutes,
                        dsmRoutes,
                        basisListRoutes,
                        basisSetupRoutes,
                        basisConfiguratorRoutes,
                        forwardItemRoutes,
                        mainMarketRoutes,
                        weightingSchemaRoutes,
                        priceFormulaRoutes,
                        runAStudyRoutes,
                        jobsRoutes,
                        variablesRoutes,
                        chartsRoutes,
                        expressJobsRoutes,
                        itemCreationWizardRoutes,
                        autoformRoutes,
                        hydroProjectRoutes,
                        realizedValuesRoutes,
                        shapeSetRoutes,
                        globalConstraintsRoutes,
                        economicReserveRoutes,
                        fuelAndEmissionsRoutes,
                        userManagementRoutes,
                        powerBIRoutes,
                        adminRoutes,
                        restorationInputExtractRoutes,
                    ],
                },
                {
                    path: '*',
                    element: <Navigate to={`/${window.location.search}`} replace />,
                },
            ],
        },
    ],
    {
        basename: process.env.PUBLIC_URL,
    }
);
